import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Copy, Check, Mail, Phone, Globe, Linkedin, ArrowRight } from 'lucide-react';
import { useUiStore } from '@/store/useUiStore';
import WordReveal from '@/components/WordReveal';
import './Ch8Contact.css';

function ContactItem({ icon, label, value, href }: { icon: React.ReactNode; label: string; value: string; href: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      /* clipboard blocked */
    }
  };
  return (
    <div className="contact-item">
      <a className="contact-item-main" href={href} target={href.startsWith('http') ? '_blank' : undefined} rel="noreferrer">
        <span className="contact-item-icon">{icon}</span>
        <span className="contact-item-text">
          <span className="contact-item-label">{label}</span>
          <span className="contact-item-value" dir="ltr">
            {value}
          </span>
        </span>
      </a>
      <button className="contact-copy" onClick={copy} aria-label={copied ? t('contact.copied') : t('contact.copy')}>
        {copied ? <Check size={16} /> : <Copy size={16} />}
      </button>
    </div>
  );
}

/** CTA / contact section — the conversion close before the footer. */
export default function Ch8Contact() {
  const { t } = useTranslation();
  const setActiveChapter = useUiStore((s) => s.setActiveChapter);

  return (
    <section
      id="contact"
      className="chapter chapter-contact"
      aria-labelledby="contact-title"
      onMouseEnter={() => setActiveChapter('contact')}
    >
      <div className="contact-inner">
        <p className="section-kicker contact-kicker">{t('contact.thanks')}</p>
        <WordReveal as="h2" className="contact-headline" text={t('ctaBand.title')} />
        <p className="contact-lead" id="contact-title">
          {t('ctaBand.lead')}
        </p>
        <div className="contact-actions">
          <a className="btn btn-primary contact-primary" href="mailto:Info@valionco.com">
            {t('ctaBand.button')}
            <ArrowRight size={18} className="contact-arrow" />
          </a>
        </div>

        <div className="contact-items">
          <ContactItem icon={<Mail size={18} />} label={t('contact.emailLabel')} value={t('contact.email')} href={`mailto:${t('contact.email')}`} />
          <ContactItem
            icon={<Phone size={18} />}
            label={t('contact.phoneLabel')}
            value={t('contact.phone')}
            href={`tel:${t('contact.phone').replace(/\s/g, '')}`}
          />
          <ContactItem icon={<Globe size={18} />} label={t('contact.webLabel')} value={t('contact.web')} href="https://www.valionco.com" />
          <ContactItem icon={<Linkedin size={18} />} label={t('contact.linkedinLabel')} value={t('contact.linkedin')} href="https://www.linkedin.com/company/valion-company" />
        </div>
      </div>
    </section>
  );
}
